<template>
  <div class="stationPopup">

    <el-button
      class="close-popup-button safe-top"
      type="text"
      icon="el-icon-close"
      @click="$emit('close')">
    </el-button>

    <div class="header-image" :style="logoPath"></div>

    <div class="status-message" :class="state" v-if="!station.public && !station.member">
      <i class="el-icon-error" /> 
      <span>
        <strong>Members only</strong><br /> 
        Be aware, this station can only be operated by members of {{station.organization.name}}.
        Please request a membership for this organization to use it.
      </span>
    </div>

    <div class="status-message" :class="state" v-else-if="station.statusType !== 0">
      <i :class="station.statusType == 1 ? 'el-icon-info' : 'el-icon-error'" />
      <span>
        <strong>{{station.statusType == 1 ? 'Maintenance' : 'Closed'}}</strong><br />
        {{ station.statusMessage }}
      </span>
    </div>

    <div class="status-message" :class="state" v-else-if="station.statusType === 0 && station.statusMessage">
      <i class="el-icon-success" />
      <span>
        {{ station.statusMessage }}
      </span>
    </div>

    <div class="station-image" v-if="station.logo">
      <img :src="station.logo.absolutePath" />
    </div>

    <div class="info">
      <h3>{{ station.name }}</h3>
      <p>
        <fa icon="home" />
        {{ station.organization.name }}
      </p>
      <p>
        <i class="el-icon-location" />
        {{ station.address + ', ' + station.zip + ' ' + station.city }}
      </p>
      <p>
        <fa icon="user" />
        {{ station.public ? 'Public' : 'Members only' }}
      </p>
      <p>
        <fa icon="dollar-sign" />
        {{  station.currency.name }}
      </p>
      <p>
        <fa icon="location-arrow" />
        {{ station.distance | distance }}
      </p>
      <p
        v-if="station.gasQualityStatus !== undefined && station.gasQualityStatus !== null"
        class="gas-quality">
        <fa icon="vial" />
        <certification-status-badge :status="station.gasQualityStatus" />
      </p>
    </div>

    

    <div class="controls">
      <el-button type="text" @click="gotoStation" icon="el-icon-view">View station</el-button>
      <el-button
        type="primary"
        icon="el-icon-share"
        v-if="canAccessStation"
        @click="accessStation">Access station</el-button>
    </div>

    <!-- <div class="controls">
      <div class="pop-status">
        <span :class="state"></span>
        Station is {{ status }}
      </div>
      <icon-button icon="el-icon-view" size="18" id="ib" />
    </div>
    <el-button class="access-station-button" type="primary" v-if="station.distance < distance.MAX_DISTANCE">Access station</el-button> -->
  </div>
</template>

<script>
import Distance from './../util/distance.js'
import axios from 'axios'
import DivegasLogo from '@/assets/logo_all_blue.png'
import distance from './../util/distance.js';
import CertificationStatusBadge from './../station/Certification/CertificationStatusBadge'

export default {
  name: 'StationPopup',
  components: { CertificationStatusBadge },
  props: {
    station: {
      type: Object,
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {
    canAccessStation () {
      const isInDistance = this.station.distance <= distance.MAX_DISTANCE
      const isPublic = this.station.public
      const isMember = this.station.member

      const isClosed = (this.station.statusType === 1) || (this.station.statusType === 2)

      if (isClosed) {
        return false
      }

      return (isInDistance && isPublic) || (isInDistance && !isPublic && isMember)
    },
    distance () {
      return Distance
    },
    readableDistance () {
      let realdistance = (this.station.distance / 1000).toFixed(2)
      if (this.$root.userLocation.enabled && !this.$root.userLocation.loading && realdistance < 1000) {
        let dist = realdistance

        if (dist < 1) {
          return dist * 1000 + ' m'
        }

        return dist + ' km'
      }

      return ''
    },
    status () {
      switch (this.station.statusType) {
        case 0:
          return 'active'
        case 1:
          return 'under maintenance'
        case 2:
          return 'closed'
      }

      return 'active'
    },
    state () {
      switch (this.station.statusType) {
        case 0:
          return ['active']
        case 1:
          return ['maintenance']
        case 2:
          return ['inactive']
      }

      return []
    },
    logoPath () {
      let obj = { backgroundImage: '' }
      if (this.station.organization.logo) {
        obj.backgroundImage = 'url(' + this.station.organization.logo.absolutePath + ')'
        obj.backgroundSize = '40% auto'
      } else {
        obj.backgroundImage = 'url(' + DivegasLogo + ')',
        obj.backgroundSize = '40% auto'
      }
      return obj
    }
  },
  methods: {
    accessStation () {
      this.$router.push({ name: 'AccessStation', params: { sId: this.station.id } })
    },
    gotoStation () {
      this.$router.push({ name: 'Station', params: { sId: this.station.id } })
    }
  },
  mounted () {}
}
</script>

<style lang="scss" scoped>

  .qr-button {
    position: absolute;
    left: 20px;
    top: 20px;
  }

  .station-image {
    img {
      width: 100%;
    }
  }

  .close-popup-button {
    position: absolute;
    right: 20px;
    top: 20px;
    font-size: 18px;
    padding: 20px;
  }

  .control-bar {
    position: absolute;
    top: -50px;
    right: 40px;
  }

  .stationPopup {
    width: 100%;
    height: 100%;
    overflow: hidden;
    box-sizing: border-box;

    display: flex;
    flex-direction: column;
  }

  .header-image {
    margin-left: auto;
    width: 100%;
    height: 200px;
    box-sizing: border-box;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
  }


  .info {
    padding: 40px;
    
    display: flex;
    flex-direction: column;

    h3 {
      margin: 0px;
      font-size: 15px;
      line-height: 15px;
      color: $text;
      margin-bottom: 40px;
    }

    p {
      margin-top: 5px;
      font-size: 13px;
      margin-bottom: 5px;

      i, svg {
        width: 15px !important;
        color: $main;
        margin-right: 12px;
      }
    }

    .distance {
      font-size: 14px;
      color: $main;
      margin-top: auto;
    }

    .gas-quality {
      display: flex;
      align-items: center;

      i, svg {
        margin-right: 12px;
      }
    }
  }

  .controls {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    button {
      margin-left: 0px;
      &:last-child {
        margin-top: auto;
        width: 100%;
        height: 60px;
      }
    }

    

    .buttons {
      margin-top: auto;
    }
  }

  .access-station-button {
    width: 100%;
    margin-top: 20px;
  }

  .status-message {
    font-size: 10px;
    padding: 15px 40px;
    display: flex;
    align-items: center;
    background-color: rgba(#F56C6C, 0.2);
    border: 0px solid rgba(#F56C6C, 0.3);
    color: #F56C6C;
    font-weight: 600;
    margin: 0px 0px;

    &.inactive {
      background-color: rgba(#F56C6C, 0.2);
      border: 0px solid rgba(#F56C6C, 0.3);
      color: #F56C6C;
    }

    &.maintenance {
      background-color: rgba(#E6A23C, 0.2);
      border: 0px solid rgba(#E6A23C, 0.3);
      color: #E6A23C;
    }

    &.active {
      background-color: rgba(#67C23A, 0.2);
      border: 0px solid rgba(#67C23A, 0.3);
      color: #67C23A;
    }

    i {
      font-size: 20px;
      margin-right: 10px;
    }
  }

  

  .pop-status {
    display: flex;
    align-items: center;
    font-size: 10px;
    span {
      display: block;
      margin-right: 10px;
      width: 8px;
      height: 8px;
      border-radius: 15px;

      &.active {
        background-color: $green;
      }

      &.inactive {
        background-color: #F56C6C;
      }

      &.maintenance {
        background-color: #E6A23C;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/stations/map/StationPopup.vue